<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ event.start|date:'EEEE, MMMM d, y':'': locale }} {{ event.title }}
            </span>
<!--            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">-->
<!--                <mat-icon>close</mat-icon>-->
<!--            </button>-->
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="eventForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="trainers && trainers.length>0">
                <mat-checkbox formControlName="isGroupActivity" fxFlex="100" (change)="checkGroupActivity($event)">
                    <mat-label>{{'Group activity'|translate}}</mat-label>
                </mat-checkbox>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="!isGroupActivity">
                <mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>{{'Customer'|translate}}</mat-label>
                    <input type="text"
                           placeholder="{{ 'Customer'|translate }}"
                           matInput
                           formControlName="customer"
                           [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option [value]="customer" *ngFor="let customer of filteredOptions|async">
                            {{customer.firstName}} {{customer.lastName}}; {{customer.phone}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error>{{'Customer is required!'|translate}}</mat-error>
                </mat-form-field>
                <div fxFlex="20">
                    <a mat-raised-button color="primary" (click)="openNewCustomerDialog()">{{'Add customer'|translate}}</a>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="isGroupActivity">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Trainer'|translate}}</mat-label>
                    <mat-select formControlName="trainer">
                        <mat-option [value]="null">

                        </mat-option>
                        <mat-option [value]="trainer.id" *ngFor="let trainer of trainers">
                            {{trainer.firstName}} {{trainer.lastName}}; {{trainer.phone}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="services.length>0">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Service'|translate}}</mat-label>
                    <mat-select formControlName="service" (ngModelChange)="getResourceGroups(eventForm.get('service').value)">
                        <mat-option [value]="null">

                        </mat-option>
                        <mat-option [value]="service.id" *ngFor="let service of services">
                            {{service.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <form [formGroup]="eventForm" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" formArrayName="reservedResources" *ngFor="let group of groups; index as i;">
                    <mat-form-field appearance="outline" fxFlex="100" *ngIf="eventForm.get('service').value" [formGroupName]="i">
                        <mat-label>{{'Resource'|translate}}</mat-label>

                        <mat-select formControlName="id" required>
                            <mat-option [value]="null">

                            </mat-option>
                            <mat-option [value]="resource.id" *ngFor="let resource of group.resources">
                                {{resource.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </form>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput formControlName="description" matAutosizeMinRows="4" matAutosizeMaxRows="80" matTextareaAutosize></textarea>
                </mat-form-field>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button *ngIf="action === 'edit'"
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(['delete',eventForm])"
                aria-label="Delete"
                matTooltip="Delete">
            {{'DELETE'|translate}}
        </button>

        <button *ngIf="action !== 'edit'"
                mat-button
                class="save-button"
                color="primary"
                (click)="matDialogRef.close(eventForm)"
                [disabled]="eventForm.invalid"
                aria-label="SAVE">
            {{'ADD'|translate}}
        </button>

        <button *ngIf="action === 'edit'"
                mat-button
                class="save-button"
                (click)="matDialogRef.close(['save',eventForm])"
                [disabled]="eventForm.invalid"
                aria-label="SAVE">
            {{'SAVE'|translate}}
        </button>

    </div>
</div>
